import React from 'react';

import { FlyoutProvider } from 'components/Flyout/FlyoutContext';
import SkuItemsPage from 'features/Sku/Items';

const SkuMenuPage = props => {
  return (
    <FlyoutProvider>
      <SkuItemsPage {...props} />
    </FlyoutProvider>
  );
};

export default SkuMenuPage;
